import React, { useId } from "react";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import style from "../scss/Select.module.scss";

const unirClases = (...clases) => clases.filter(Boolean).join(" ");

// Select único de la app (react-select sin estilos propios: todo el diseño
// vive en Select.module.scss). Es controlado: recibe el value de la opción
// seleccionada y entrega solo el value en onCambiar (null al limpiar).
// opciones: [{ value, label }]
// creable: además de elegir, permite escribir un valor nuevo. onCrear recibe
// el texto escrito (si no se pasa, el texto nuevo se entrega en onCambiar).
const SelectComponent = (props) => {
  const {
    id,
    name,
    etiqueta,
    claseEtiqueta,
    opciones = [],
    valor = null,
    onCambiar,
    placeholder = "Seleccionar…",
    buscable = true,
    limpiable = true,
    deshabilitado = false,
    requerido = false,
    grande = false,
    creable = false,
    onCrear,
    textoCrear = (texto) => `Agregar "${texto}"`,
  } = props;

  const idGenerado = useId();
  const inputId = id ?? `select-${idGenerado}`;
  const Componente = creable ? CreatableSelect : Select;

  // se compara como texto: las mesas llegan como número o como string.
  // En un select creable, un valor que aún no está en las opciones se muestra igual.
  const sinValor = valor === null || valor === undefined || valor === "";
  const encontrada = sinValor ? null : opciones.find((opcion) => String(opcion.value) === String(valor));
  const seleccionada = encontrada ?? (!sinValor && creable ? { value: valor, label: String(valor) } : null);

  const propsCreable = creable
    ? {
        onCreateOption: (texto) => (onCrear ? onCrear(texto) : onCambiar?.(texto)),
        formatCreateLabel: textoCrear,
        createOptionPosition: "first",
      }
    : {};

  return (
    <div className={style.campo}>
      {etiqueta && (
        <label htmlFor={inputId} className={unirClases(style.etiqueta, claseEtiqueta)}>
          {etiqueta}
        </label>
      )}
      <Componente
        {...propsCreable}
        unstyled
        inputId={inputId}
        name={name}
        options={opciones}
        value={seleccionada}
        onChange={(opcion) => onCambiar?.(opcion?.value ?? null)}
        placeholder={placeholder}
        isSearchable={buscable}
        isClearable={limpiable}
        isDisabled={deshabilitado}
        required={requerido}
        noOptionsMessage={() => "Sin resultados"}
        // el menú va al body para que no lo recorten tarjetas, tablas ni modales
        menuPortalTarget={document.body}
        menuPlacement="auto"
        classNames={{
          control: ({ isFocused, isDisabled, menuIsOpen }) =>
            unirClases(
              style.control,
              grande && style.controlGrande,
              (isFocused || menuIsOpen) && style.controlFoco,
              isDisabled && style.controlDeshabilitado
            ),
          valueContainer: () => style.contenedorValor,
          placeholder: () => style.placeholder,
          singleValue: () => style.valor,
          input: () => style.input,
          indicatorsContainer: () => style.indicadores,
          indicatorSeparator: () => style.separador,
          clearIndicator: () => style.limpiar,
          dropdownIndicator: ({ selectProps }) =>
            unirClases(style.flecha, selectProps.menuIsOpen && style.flechaAbierta),
          menuPortal: () => style.portal,
          menu: () => style.menu,
          menuList: () => style.lista,
          option: ({ isFocused, isSelected }) =>
            unirClases(style.opcion, isFocused && style.opcionFoco, isSelected && style.opcionSeleccionada),
          noOptionsMessage: () => style.vacio,
        }}
      />
    </div>
  );
};

export default SelectComponent;
